import axios from 'axios';


const searchApi = axios.create({
    baseURL: 'https://api.mapbox.com/geocoding/v5/mapbox.places',
    params: {
        limit: 5,
        language: 'es',
        access_token: 'pk.eyJ1IjoiaWFtYm9ubmUiLCJhIjoiY2x6MXZycjh0MDRoNjJrb2c5ZzVkOXZweCJ9.YvjY8yFRvS1GPF9MXhCgmg'
    }
});


export default searchApi;


